import React from 'react';
import styles from './index.css';
import { h5PageCount } from '../../../utils';
class HomeFooter extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.clickCountFn = (clickConfig, url) => {
            if (clickConfig) {
                h5PageCount([clickConfig]);
            }
            setTimeout(() => {
                location.href = url;
            }, 50);
        };
    }
    render() {
        const { content } = this.props;
        const footerItem = content.map((item, index) => (React.createElement("li", { className: styles.footerItem, key: index },
            React.createElement("a", { onClick: this.clickCountFn.bind(this, item.clickConfig, item.url), className: styles.footerLink }, item.title))));
        return (React.createElement("footer", { className: styles.footer },
            React.createElement("ul", { className: styles.footerBox }, footerItem)));
    }
}
export default HomeFooter;
